import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "selection", "list", "template"]

  choose() {
    this.inputTarget.click()
  }

  preview() {
    this.listTarget.replaceChildren()
    this.selectionTarget.hidden = this.inputTarget.files.length === 0
    Array.from(this.inputTarget.files).forEach((file, index) => {
      const row = this.templateTarget.content.cloneNode(true)
      const size = file.size < 1024 ? `${file.size} B` : `${(file.size / 1024).toFixed(1)} KB`
      row.querySelector("[data-filename]").textContent = `${file.name} (${size})`
      row.querySelector("button").dataset.index = index
      this.listTarget.appendChild(row)
    })
  }

  remove(event) {
    const files = new DataTransfer()
    const removedIndex = Number(event.currentTarget.dataset.index)
    Array.from(this.inputTarget.files).forEach((file, index) => {
      if (index !== removedIndex) files.items.add(file)
    })
    this.inputTarget.files = files.files
    this.preview()
    this.element.querySelector("button").focus()
  }
}
